<template>
  <aside class="widget">
    <h4>Helpful Resources</h4>
    <table class="table table-sm table-borderless">
      <tbody class="text-center">
        <tr>
          <!-- <td>
            <a href="https://peoplesoft.multichoice.co.za" class="btn btn-outline-primary btn-block" target="_blank">
              <i class="far fa-user-circle fa-2x fa-fw mb-1"></i><br><small>PeopleSoft</small>
            </a>
          </td>-->
          <td>
            <a href="https://naspers.sharepoint.com/sites/enrich/SitePages/Enrich/Enrich.aspx#/home" class="btn btn-outline-danger btn-block" target="_blank">
              <i class="fas fa-spinner fa-2x fa-fw mb-1"></i><br><br><small>Enrich</small>
            </a>
          </td>
          <td>
            <a href="https://passwordreset.multichoice.co.za/Persona_PWReset/" target="_blank" class="btn btn-outline-info btn-block">
              <i class="fas fa-lock fa-2x fa-fw mb-1"></i><br><small>Password<br>Reset</small>
            </a>
          </td>
        </tr>
        <!-- <tr>
          <td>
            <a href="https://secure.etweb.axiapayroll.co.za/MultiChoiceAfrica11/" class="btn btn-outline-secondary btn-block" target="_blank">
              <i class="far fa-star fa-2x fa-fw mb-1"></i><br><small>eTalent</small>
            </a>
          </td>
          <td>
            <a href="http://mih-global.com" class="btn btn-outline-success btn-block" target="_blank">
              <i class="fas fa-book fa-2x fa-fw mb-1"></i><br><small>Signify<br>eLearning</small>
            </a>
          </td>
          <td>
            <a href="http://24mlife.co.za" class="btn btn-outline-warning btn-block" target="_blank">
              <i class="fas fa-heart fa-2x fa-fw mb-1"></i><br><small>MLife <br>Portal</small>
            </a>
          </td>
        </tr> -->
      </tbody>
    </table>
  </aside>
</template>

<script>

export default {
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HelpfulResources.vue